export class ImportTemplateErrorResponse {
  id: any;
}
